'use es6';

import I18n from 'I18n';
import CustomWidgetTags from 'ContentUtils/constants/CustomWidgetTags';
import ModuleCompatibilityTagTypes from 'marketplace-lib/constants/ModuleCompatibilityTagTypes';
import ModulePurposeOptions from '../constants/CustomModulePurposeOptions';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import GoodSubTypes from '../constants/GoodSubTypes';
import PayPalPurchaseErrors from '../constants/PayPalPurchaseErrors';
import ProviderOptions from '../constants/ProviderOptions';
import StripePurchaseErrors from '../constants/StripePurchaseErrors';
import UninstallModalTypes from '../constants/UninstallModalTypes';
export function getErrorPageDescriptionStart(asset) {
  if (asset.get('connectionType') === 'site_settings_500') {
    return I18n.text('uninstallModal.errorPageDescription.500PageStart');
  } else if (asset.get('connectionType') === 'site_settings_404') {
    return I18n.text('uninstallModal.errorPageDescription.404PageStart');
  } else if (asset.get('connectionType') === 'site_settings_password_prompt') {
    return I18n.text('uninstallModal.errorPageDescription.passwordPromptStart');
  }

  return '';
}
export function getErrorPageDescriptionEnd(asset) {
  if (asset.get('type') === 'SITE_SETTINGS') {
    return I18n.text('uninstallModal.errorPageDescription.allDomains');
  }

  return "" + (asset.getIn(['model', 'domain']) || '');
}
export function getSubscriptionPageDescription(asset) {
  if (asset.get('connectionType') === 'site_settings_subscription_preferences') {
    return I18n.text('uninstallModal.subscriptionPageDescription.preferences');
  } else if (asset.get('connectionType') === 'site_settings_unsubscribe_backup') {
    return I18n.text('uninstallModal.subscriptionPageDescription.backupUnsubscribe');
  } else if (asset.get('connectionType') === 'site_settings_subscription_confirmation') {
    return I18n.text('uninstallModal.subscriptionPageDescription.updateConfirmation');
  }

  return '';
}
export function getPackCountsItem(subType, count) {
  return I18n.text("packCounts." + subType, {
    count: count
  });
}
export function getPackCountsTitle(numberOfTemplates) {
  return I18n.text('packCounts.title', {
    numberOfTemplates: numberOfTemplates
  });
}
export function getGoodPriceMessage(isFree, goodPrice) {
  return isFree ? I18n.text('goodTile.price.free') : "" + I18n.formatCurrency(goodPrice, {
    unit: '$',
    precision: 0
  });
}
export function getFriendlySortingOptionName(sortingFilter) {
  return I18n.text("sortingBar.sortingOptions." + sortingFilter);
}
export function getFriendlyCategoryFilterName(goodSubTypeFilter) {
  return I18n.text("sortingBar.goodSubTypeFilterOptions." + goodSubTypeFilter);
}
export function getCategoryOptionText(categoryOption) {
  return I18n.text("sidebar.category." + categoryOption);
}
export function getSystemPageOptionText(systemPageOption) {
  return I18n.text("header.systemPageOptions." + systemPageOption);
}
export function getIndustryOptionText(industryOptionOrTitle) {
  if (industryOptionOrTitle === 'title' || industryOptionOrTitle === 'ALL') {
    return I18n.text("sidebar.industryFilter." + industryOptionOrTitle);
  }

  return I18n.text("tagNames.industryTag." + industryOptionOrTitle);
}
export function getTemplatePurposeOptionText(templatePurposeOrTitle) {
  if (templatePurposeOrTitle === 'title' || templatePurposeOrTitle === 'ALL') {
    return I18n.text("sidebar.templatePurposeFilter." + templatePurposeOrTitle);
  }

  return I18n.text("tagNames.templatePurposeTag." + templatePurposeOrTitle);
}
export function getCustomModulePurposeOptionText(purposeOptionOrTitle) {
  if (purposeOptionOrTitle === 'title' || purposeOptionOrTitle === 'fullTitle' || purposeOptionOrTitle === ModulePurposeOptions.NONE) {
    return I18n.text("sidebar.customModulePurposeFilter." + purposeOptionOrTitle);
  }

  return I18n.text("contentUtils.cmv2Tags." + CustomWidgetTags[purposeOptionOrTitle]);
}
export function getCustomModuleCompatibilityOptionText(compatibilityOptionOrTitle) {
  if (compatibilityOptionOrTitle === 'title' || compatibilityOptionOrTitle === ModuleCompatibilityTagTypes.COMPATIBLE_ANY) {
    return I18n.text("sidebar.customModuleCompatibilityFilter." + compatibilityOptionOrTitle);
  }

  return I18n.text("marketplacelib.ModuleCompatibilityTagTypes." + compatibilityOptionOrTitle);
}
export function getPageLayoutOptionText(pageLayoutOptionOrTitle) {
  if (pageLayoutOptionOrTitle === 'title' || pageLayoutOptionOrTitle === 'ALL') {
    return I18n.text("sidebar.pageLayoutFilter." + pageLayoutOptionOrTitle);
  }

  return I18n.text("tagNames.layoutTag." + pageLayoutOptionOrTitle);
}
export function getPurchaseErrorHeaderKey(purchaseError) {
  var messageKey;

  switch (purchaseError) {
    case PayPalPurchaseErrors.PROVIDER_ERROR:
      {
        messageKey = 'providerErrorHeader';
        break;
      }

    default:
      {
        messageKey = 'header';
        break;
      }
  }

  return "MarketplaceUI.goodDetailsPage.purchaseErrorModal." + messageKey;
}
export function getPurchaseErrorMessageKey(purchaseError) {
  var messageKey;

  switch (purchaseError) {
    case StripePurchaseErrors.STRIPE_CHECKOUT_FAILED:
    case PayPalPurchaseErrors.PAYPAL_PURCHASE_FAILED:
      {
        messageKey = 'genericMessage';
        break;
      }

    case PayPalPurchaseErrors.PROVIDER_ERROR:
      {
        messageKey = 'providerErrorMessage';
        break;
      }

    case StripePurchaseErrors.CARD_DECLINED:
      {
        messageKey = 'cardDeclinedMessage';
        break;
      }

    case StripePurchaseErrors.INVALID_NUMBER:
      {
        messageKey = 'invalidNumberMessage';
        break;
      }

    case StripePurchaseErrors.INVALID_EXPIRY_MONTH:
      {
        messageKey = 'invalidExpiryMonthMessage';
        break;
      }

    case StripePurchaseErrors.INVALID_EXPIRY_YEAR:
      {
        messageKey = 'invalidExpiryYearMessage';
        break;
      }

    case StripePurchaseErrors.INVALID_CVC:
      {
        messageKey = 'invalidCvcMessage';
        break;
      }

    case StripePurchaseErrors.INCORRECT_NUMBER:
      {
        messageKey = 'incorrectCardNumberMessage';
        break;
      }

    case StripePurchaseErrors.EXPIRED_CARD:
      {
        messageKey = 'expiredCardMessage';
        break;
      }

    case StripePurchaseErrors.INCORRECT_CVC:
      {
        messageKey = 'incorrectCvcMessage';
        break;
      }

    case StripePurchaseErrors.INCORRECT_ZIP:
      {
        messageKey = 'incorrectZipMessage';
        break;
      }

    case StripePurchaseErrors.PROCESSING_ERROR:
      {
        messageKey = 'processingErrorMessage';
        break;
      }

    default:
      {
        messageKey = 'genericMessage';
        break;
      }
  }

  return "MarketplaceUI.goodDetailsPage.purchaseErrorModal." + messageKey;
}
export function getCodingTypeOptionOrTitleText(codingTypeOptionOrTitle) {
  if (codingTypeOptionOrTitle === 'title') {
    return I18n.text("sidebar.codingTypeFilter." + codingTypeOptionOrTitle);
  }

  return I18n.text("tagNames.codingType." + codingTypeOptionOrTitle);
}
export function getGoodsPriceOptionOrTitleText(goodsPriceOptionOrTitle) {
  return I18n.text("sidebar.goodsPriceFilter." + goodsPriceOptionOrTitle);
}
export function getGoodSubtypeText(goodSubType) {
  return I18n.text("goodSubtype." + goodSubType, {
    defaultValue: ''
  });
}
export function getPackCountsOverflowText(packCounts, firstOverflowIndex) {
  var numberOfMoreTemplates = packCounts.slice(firstOverflowIndex).reduce(function (previousTotal, packCount) {
    return previousTotal + packCount.get('count');
  }, 0);
  return I18n.text('packCounts.overflowText', {
    numberOfMoreTemplates: numberOfMoreTemplates
  });
}
export function getManagePurchasesColumnText(columnType) {
  return I18n.text("managePurchases.tableColumns." + columnType);
}
export function getManagePurchasesZeroStateText(zeroStateType) {
  return I18n.text("managePurchases.zeroState." + zeroStateType);
}
export function getCharactersRemainingText(maxCharacters, charactersUsed) {
  var numberOfCharactersRemaining = maxCharacters - charactersUsed;
  return I18n.text('reviewModal.charactersRemaining', {
    numberOfCharactersRemaining: numberOfCharactersRemaining,
    count: numberOfCharactersRemaining
  });
}
export function getDetailsPanelText(field) {
  return I18n.text("managePurchases.detailsRow." + field);
}
export function getManagePurchasesPriceText(isFree, goodPrice) {
  return isFree ? I18n.text('managePurchases.detailsRow.free') : "$" + goodPrice;
}
export function getPaidViaText(paymentType) {
  return I18n.text("managePurchases.detailsRow.paidVia." + paymentType);
}
export function getPaidByText(buyerEmail) {
  return I18n.text('managePurchases.detailsRow.paidBy', {
    buyerEmail: buyerEmail
  });
}
export function getRefundStatusTagKey(status) {
  return "managePurchases.detailsRow.refundStatusTag." + status;
}
export function getRefundStatusButtonKey(status) {
  return "managePurchases.detailsRow.refundStatusButton." + status;
}
export function getFeatureOptionOrTitleText(filterOrTitle) {
  if (filterOrTitle === 'NONE' || filterOrTitle === 'fullTitle') {
    return I18n.text("sidebar.COS_TEMPLATE_FEATURES." + filterOrTitle);
  }

  return I18n.text("tagNames.featureTags." + filterOrTitle);
}
export function getChildTypeOptionOrTitleText(optionOrTitle) {
  return I18n.text("sidebar.childType." + optionOrTitle);
}
export function getMultiselectFilterOptionOrTitleText(filterType, filterOptionOrTitle) {
  if (filterType === GoodFiltersAndPage.CHILD_TYPES) {
    return getChildTypeOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === GoodFiltersAndPage.PRICE) {
    return getGoodsPriceOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === GoodFiltersAndPage.CODING_TYPE) {
    return getCodingTypeOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === GoodFiltersAndPage.FEATURES) {
    return getFeatureOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === GoodFiltersAndPage.MODULE_COMPATIBILITY) {
    return getCustomModuleCompatibilityOptionText(filterOptionOrTitle);
  } else if (filterType === GoodFiltersAndPage.MODULE_PURPOSE) {
    return getCustomModulePurposeOptionText(filterOptionOrTitle);
  }

  return '';
}
export function getSortedSelectedFilters(filterType, selectedFilters) {
  return selectedFilters.sort(function (filter1, filter2) {
    return getMultiselectFilterOptionOrTitleText(filterType, filter1).localeCompare(getMultiselectFilterOptionOrTitleText(filterType, filter2));
  });
}
export function getMultiselectMaxText(maxSelections) {
  return I18n.text('MarketplaceUI.directory.sidebar.multiselectDropdownFilter.maxSubtitle', {
    maxSelections: maxSelections
  });
}
export function getHeaderTabText(tabId) {
  return I18n.text("header." + tabId);
}
export function getProviderOptionText(providerOption) {
  if (providerOption === ProviderOptions.ALL) {
    return I18n.text('sidebar.providerFilter.ALL');
  }

  return providerOption;
}
export function getPurchasedOnText(date) {
  var formattedDate = I18n.moment.utc(date).format('ll');
  return I18n.text('managePurchases.detailsRow.purchasedOn', {
    formattedDate: formattedDate
  });
}
export function getUninstallModalHeader(modalType) {
  if (modalType === UninstallModalTypes.SEE_WHERE_IN_USE) {
    return I18n.text('uninstallModal.header.SEE_WHERE_IN_USE');
  } else if (modalType === UninstallModalTypes.ATTEMPTED_UNINSTALL_INDIVIDUAL || modalType === UninstallModalTypes.ATTEMPTED_UNINSTALL_PACK) {
    return I18n.text('uninstallModal.header.ATTEMPTED_UNINSTALL');
  }

  return I18n.text('uninstallModal.header.ATTEMPTED_REFUND');
}
export var getContentCreateAccessErrorKey = function getContentCreateAccessErrorKey(goodSubType) {
  var contentTypeKey;

  switch (goodSubType) {
    case GoodSubTypes.EMAIL_TEMPLATES:
      {
        contentTypeKey = 'email';
        break;
      }

    case GoodSubTypes.LANDING_PAGES:
      {
        contentTypeKey = 'landingPage';
        break;
      }

    case GoodSubTypes.SITE_PAGES:
      {
        contentTypeKey = 'sitePage';
        break;
      }

    default:
      {
        contentTypeKey = 'default';
        break;
      }
  }

  return "MarketplaceUI.errors.contentCreateAccess." + contentTypeKey;
};